import React from 'react'
import {observer} from 'mobx-react'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PlayerMenu from './PlayerMenu'
import PropTypes from 'prop-types';

import './procedureFooter.scss'
import ConditionalComponent from "../../Shared/ConditionalComponent";
import {procedureNodeTypeEnum} from "../../../serverClientShared/sharedEnums";
import {useStores} from "../../../Hooks";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import Utility from "../../../Utility";
import {isTablet, isIOS} from "react-device-detect";
import {Button} from "@mui/material";

const isIphone = isIOS && !isTablet;

const ProcedureFooter = observer(({fullscreenRefElement, isPreview, withoutFullScreen}) => {
    const {procedureStore, generalStore} = useStores();

    const currentNode = (isPreview ? procedureStore.currentPreviewedNode : procedureStore.currentNode) || {};
    const isEndNode = currentNode.NodeType === procedureNodeTypeEnum.END;
    const isStartNode = currentNode.NodeType === procedureNodeTypeEnum.START || !currentNode.NodeType;

    function renderRefreshButton() {
        return <ConditionalComponent if={!isStartNode}>
            <Button
                className="refresh-node-btn"
                onClick={() => !isEndNode && procedureStore.restart2D(isPreview, false)}
                endIcon={<AutorenewIcon fontSize='large'/>}
            >
                <span className="hide-when-small">{generalStore.translate('startOver')}</span>
            </Button>
        </ConditionalComponent>;
    }

    function renderFullScreenButton() {
        return <ConditionalComponent if={!isIphone && !withoutFullScreen}>
            <div className="full-screen-btn" onClick={() => Utility.toggleFullScreen(fullscreenRefElement)}>
                {generalStore.isInFullscreen ? <FullscreenExitIcon/> : <FullscreenIcon/>}
            </div>
        </ConditionalComponent>;
    }

    return (
        <div className="procedure-footer">
            <ConditionalComponent if={!isEndNode && !procedureStore.sessionViewerOpen}>
                {renderRefreshButton()}
                <PlayerMenu isPreview={isPreview} isStartNode={!!isStartNode}/>
            </ConditionalComponent>
            {renderFullScreenButton()}
        </div>
    )
});

ProcedureFooter.propTypes = {
    isPreview: PropTypes.bool.isRequired,
    fullscreenRefElement: PropTypes.element
}

export default ProcedureFooter
